import { ChakraProvider } from '@chakra-ui/react'

import store from '@core/app/store/store'
import { IsApplyDialogProvider } from '@core/utils/contexts/ApplyDialogContext/ApplDialogContext'
import { ModalProvider } from '@core/utils/contexts/ModalContext/ModalContextProvider'
import { ThemeProvider } from '@core/utils/contexts/ThemeContext/ThemeContext'
import { CustomURL, generateRoutes } from '@core/utils/helpers/customeRouteBuilder'
import ErrorBoundary from '@core/utils/helpers/errorBoundary'

import '@core/utils/i18n'
import React from 'react'

import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import { initSentry } from '@core/utils/sentry/initSentry'
import '../../index.css'

import theme from '../../theme'
import { CompanyPage } from './CompanyPage'

initSentry()

const app = document.getElementById('root')
const root = createRoot(app!)

const urls = generateRoutes('', '/')

const routeCollection: object[] = []

urls.forEach((element: CustomURL) => {
    routeCollection.push({
        path: element.url,
        element: (
            <ErrorBoundary fallback={<div>Something went wrong...</div>}>
                <IsApplyDialogProvider>
                    <ThemeProvider>
                        <CompanyPage />
                    </ThemeProvider>
                </IsApplyDialogProvider>
            </ErrorBoundary>
        ),
    })
})

const router = createBrowserRouter(routeCollection)

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ChakraProvider theme={theme}>
                <ModalProvider>
                    <RouterProvider router={router} />
                </ModalProvider>
            </ChakraProvider>
        </Provider>
    </React.StrictMode>
)
